// Lib
import React from 'react';

// Components
import LineControlPointDragPreview from '../../../element/line/dragPreview/LineControlPointDragPreview';
import ElementPositioner from '../../../element/ElementPositioner';

// Types
import { LineDragLayerProps } from '../dragTypes';

export const DraggedLineControlPointPreview = ({ item, offsetDiff, gridSize }: LineDragLayerProps) => (
    <ElementPositioner elementId={item.id}>
        <LineControlPointDragPreview
            elementId={item.id}
            element={item.element}
            offsetDiff={offsetDiff}
            pos={item.pos}
            gridSize={gridSize}
        />
    </ElementPositioner>
);
